<template>
    <span data-component="CartOverviewStatuses"
          class="cart-overview-statuses">
        <!-- Paid Status-->
        <OrderPaidStatusLabel :order="cart.originalOrder" />

        <!-- Fulfillment Status -->
        <FulfillmentStatusLabel :fulfillments="cart.restoredKitchenOrder.fulfillments" />
    </span>
</template>

<script>

import FulfillmentStatusLabel from '@/vue/components/Badges/FulfillmentStatusLabel';
import OrderPaidStatusLabel from '@/vue/components/Badges/OrderPaidStatusLabel';

export default {
    components: {
        FulfillmentStatusLabel,
        OrderPaidStatusLabel,
    },

    props: {
        cart: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="less">
.cart-overview-statuses {
    .label {
        margin-left: 3px;
        margin-bottom: 3px;
    }
}
</style>
